import {
	GET_USER_MANAGEMENT_LIST,
	GET_USER_MANAGEMENT_LIST_FAILED,
	GET_USER_MANAGEMENT_LIST_SUCCESS,
	GET_USER_MANAGEMENT_LIST_RESET,
	POST_CREATE_USER_REQUEST,
	POST_CREATE_USER_REQUEST_SUCCESS,
	POST_CREATE_USER_REQUEST_FAILED,
	POST_CREATE_USER_REQUEST_RESET,
	DELETE_USER_REQUEST,
	DELETE_USER_REQUEST_SUCCESS,
	DELETE_USER_REQUEST_FAILED,
	DELETE_USER_REQUEST_RESET,
	EMAIL_AVAILABILITY_CHECK_SUCCESS,
	EMAIL_AVAILABILITY_CHECK_FAILED,
	EMAIL_AVAILABILITY_CHECK_RESET,
	UPDATE_USER_REQUEST,
	UPDATE_USER_REQUEST_SUCCESS,
	UPDATE_USER_REQUEST_FAILED,
	UPDATE_USER_REQUEST_RESET,
	GET_CASE_ACCESS_LIST,
	GET_CASE_ACCESS_LIST_SUCCESS,
	GET_CASE_ACCESS_LIST_FAIL,
	GET_CASE_ACCESS_LIST_RESET,
} from "../types"
import { INACTIVE_CASE_STATUS } from "../utils"

const initialState = {
	usersList: [],
	isUsersListLoading: false,
	isUserCreated: false,
	userData: {},
	isUserDeleted: false,
	isUserDeletedLoading: false,
	isEmailAvailaible: false,
	isUserUpdated: false,
	isUserUpdateLoading: false,
	caseList: [],
	caseListLoading: false,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_USER_MANAGEMENT_LIST:
			return {
				...state,
				isUsersListLoading: true,
			}
		case GET_USER_MANAGEMENT_LIST_SUCCESS:
			return {
				...state,
				isUsersListLoading: false,
				usersList: action.payload,
			}
		case GET_USER_MANAGEMENT_LIST_FAILED:
			return {
				...state,
				isFromEmailsLoading: false,
			}
		case GET_USER_MANAGEMENT_LIST_RESET:
			return {
				...initialState,
			}
		case POST_CREATE_USER_REQUEST_SUCCESS:
			return {
				...state,
				isUserCreated: true,
				userData: action.payload,
			}
		case POST_CREATE_USER_REQUEST_FAILED:
			return {
				...state,
				isUserCreated: false,
				userData: {},
			}
		case POST_CREATE_USER_REQUEST_RESET:
			return {
				...state,
				isUserCreated: false,
				userData: {},
			}
		case DELETE_USER_REQUEST:
			return {
				...state,
				isUserDeletedLoading: true,
			}
		case DELETE_USER_REQUEST_SUCCESS:
			return {
				...state,
				isUserDeletedLoading: false,
				isUserDeleted: true,
			}
		case DELETE_USER_REQUEST_FAILED:
			return {
				...state,
				isUserDeletedLoading: false,
				isUserDeleted: false,
			}
		case DELETE_USER_REQUEST_RESET:
			return {
				...state,
				isUserDeletedLoading: false,
				isUserDeleted: false,
			}
		case EMAIL_AVAILABILITY_CHECK_SUCCESS:
			return {
				...state,
				isEmailAvailaible: true,
			}
		case EMAIL_AVAILABILITY_CHECK_FAILED:
			return {
				...state,
				isEmailAvailaible: false,
			}
		case EMAIL_AVAILABILITY_CHECK_RESET:
			return {
				...state,
				isEmailAvailaible: false,
			}
		case UPDATE_USER_REQUEST:
			return {
				...state,
				isUserUpdateLoading: true,
			}
		case UPDATE_USER_REQUEST_SUCCESS:
			return {
				...state,
				isUserUpdateLoading: false,
				isUserUpdated: true,
			}
		case UPDATE_USER_REQUEST_FAILED:
			return {
				...state,
				isUserUpdateLoading: false,
				isUserUpdated: false,
			}
		case UPDATE_USER_REQUEST_RESET:
			return {
				...state,
				isUserUpdateLoading: false,
				isUserUpdated: false,
			}
		case GET_CASE_ACCESS_LIST:
			return {
				...state,
				caseListLoading: true,
			}
		case GET_CASE_ACCESS_LIST_SUCCESS:
			let caseData = []
			const caseCount = action?.payload?.length
			if (caseCount > 0) {
				for (let i = 0; i < caseCount; i++) {
					if (!INACTIVE_CASE_STATUS?.includes(action?.payload[i]?.current_activity)) {
						const newElement = {
							project_id: action?.payload[i]?.project_id,
							friendly_name: action?.payload[i]?.name,
							case_mode: action?.payload[i]?.case_mode,
							current_activity: action?.payload[i]?.current_activity,
							case_id: action?.payload[i]?.case_id,
						}
						caseData?.push(newElement)
					}
				}
			}
			return {
				...state,
				caseList: caseData,
				caseListLoading: false,
			}
		case GET_CASE_ACCESS_LIST_FAIL:
			return {
				...state,
				caseListLoading: false,
			}
		case GET_CASE_ACCESS_LIST_RESET:
			return {
				...state,
				caseListLoading: false,
				caseList: [],
			}
		default:
			return state
	}
}
